<template>
    <v-card flat>
        <!-- <v-card-text> -->

        <MaterialesTable :materiales="materiales" :disabled="parte.bloqueado || parte.estadoParte_id == 5"
            :showOriginalValues="showOriginal" @deleteItem="confirmDeleteMaterial" :loading="loading"
            @editItem="editMaterial" @newItem="addMaterial">
            <v-btn color="primary" outlined @click="showOriginal = !showOriginal">
                {{ showOriginal ? 'Ocultar originales' : 'Mostrar originales' }}
            </v-btn>
        </MaterialesTable>

        <BaseConfirmDelete v-model="confirmDelete" @confirm="deleteMaterial" confirm-text="Eliminar"
            message="¿Estás seguro de que quieres eliminar el material?" />

        <MaterialEdit v-model="itemToEdit" v-if="showEditMaterial" :disabled="parte.bloqueado || parte.estadoParte_id == 5"
            @close="showEditMaterial = false" @deleteItem="confirmDeleteMaterial" @saveItem="saveMaterial">
        </MaterialEdit>

        <MaterialNew @close="showAddMaterial = false" v-if="showAddMaterial" @saveItem="insertMaterial" />
        <!-- </v-card-text> -->
    </v-card>
</template>


<script>
import { mapGetters, mapActions } from "vuex";

import MaterialesTable from '@/components/materiales/MaterialesTable'
import MaterialEdit from '@/components/materiales/MaterialEdit'
import MaterialNew from '@/components/materiales/MaterialNew'
import BaseConfirmDelete from '@/components/utils/BaseConfirmDelete'

export default {
    name: "Materiales",
    props: ["parte"],
    components: {
        MaterialesTable,
        MaterialEdit,
        MaterialNew,
        BaseConfirmDelete
    },
    data() {
        return {
            showOriginal: false,
            confirmDelete: false,
            itemToDelete: null,
            showEditMaterial: false,
            itemToEdit: {},
            showAddMaterial: false
        }
    },
    methods: {
        ...mapActions(["setSnackbar"]),
        confirmDeleteMaterial(item) {
            this.confirmDelete = true
            this.itemToDelete = Object.assign({}, item)
        },
        deleteMaterial() {
            this.confirmDelete = false
            this.$store.dispatch('materiales/deleteMaterial', this.itemToDelete)
                .finally(() => {
                    this.itemToDelete = Object.assign({})
                })
        },
        editMaterial(item) {
            this.showEditMaterial = true
            // this.itemToEdit = Object.assign({}, item)
            this.itemToEdit = { ...item }
        },
        saveMaterial() {
            this.$store.dispatch('materiales/updateMaterial', this.itemToEdit)
                .finally(() => {
                    this.itemToEdit = {}
                })
        },
        addMaterial() {
            this.showAddMaterial = true
        },
        insertMaterial(item) {
            this.$store.dispatch('materiales/insertMaterial', item)
            console.log(this.$store.getters['materiales/materialesRequest'])
        }
    },
    computed: {
        ...mapGetters({
            materiales: "materiales/materiales",
            loading: "materiales/loading",
        }),
    },
    mounted() {
        this.$store.dispatch('materiales/getMaterialesParte', this.parte.id)
            .catch(err => {
                this.setSnackbar({
                    tipo: "error",
                    mensaje: "Error. No se han podido cargar los materiales del parte.",
                });
            })
    },
    destroyed() {
        this.$store.dispatch('materiales/resetStore')
    },
}
</script>